import { createBrowserClient } from "@supabase/ssr";
import { wrapSupabaseClient } from "./timeout-handler";

// Create a singleton instance of the Supabase client
let supabaseClient = null;

export function createClient() {
  // Return existing client if available
  if (supabaseClient) {
    return supabaseClient;
  }

  // Create new client
  const rawClient = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL || "https://api.qensa.me",
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    {
      auth: {
        autoRefreshToken: true, // Keep this enabled for automatic token refresh
        persistSession: true, // Keep sessions persistent across page reloads
        detectSessionInUrl: false, // Disable to prevent conflicts with autosave
      },
      realtime: {
        enabled: false, // Disable realtime completely
      },
    }
  );

  // Wrap the client with timeout handling
  supabaseClient = wrapSupabaseClient(rawClient);

  return supabaseClient;
}

// Export a pre-initialized instance
export const supabase = createClient();
